module.exports = __webpack_public_path__ + "img/accident.4481bdbd.jpg";